import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found-page',
  imports: [CommonModule, RouterLink],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
  standalone: true,
})

export class NotFoundPageComponent {
  constructor() { }

  ngOnInit(): void {

  }

  goBack(): void {
    window.history.back();
  }
}
